import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

/** Aba "Completo": texto cru do laboratório, sem interpretação — espelha o que
 *  a versão em produção exibe. Os cabeçalhos de categoria ("Altas:",
 *  "Moderadas:") ganham destaque para separar visualmente os blocos. */
export const ContainerTextoCompleto = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px 2px;

  .linha__completa {
    font-size: 12px;
    line-height: 1.6;
    color: var(--text-color, #303030);
    margin: 0;
    word-break: break-word;

    b,
    strong {
      font-weight: 600;
    }
  }

  /* "Altas:" / "Moderadas:" vêm sozinhos na linha e servem de subtítulo. */
  .linha__completa[data-cabecalho='true'] {
    font-size: 13px;
    font-weight: 700;
    margin-top: 6px;

    &:first-child {
      margin-top: 0;
    }
  }
`

/** Bloco das linhas que o parser não conseguiu estruturar — exibidas como texto,
 *  espelhando a produção, para que nenhuma inconsistência seja escondida. */
export const ContainerNaoInterpretadas = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;
  margin-top: 8px;
  border-radius: 8px;
  background-color: var(--primary-a10, #f5f5f5);
  border: 1px solid var(--border-color, #e0e0e0);

  .titulo__nao-interpretadas {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-color-light, #7d7d7d);
  }

  .linha__nao-interpretada {
    font-size: 12px;
    line-height: 1.5;
    color: var(--text-color, #303030);
    margin: 0;
  }
`
